const T=15,e=6e4,o=1e4;var E={COUNTDOWN_MINUTES:15,THROTTLE_TIME:6e4,THROTTLE_INTERVAL:1e4,showCountdownTimer:!1};export{T as COUNTDOWN_MINUTES,o as THROTTLE_INTERVAL,e as THROTTLE_TIME,E as default};
//# sourceMappingURL=config.js.map
